/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import moment from "moment";
import { Dropdown, Tooltip } from "antd";
import { CustomIcon } from 'datastake-daf/dist/components';
import { renderSeverity, renderStatus } from "./helper";

/**
 * 
 * @param {*} t translation 
 * @param {*} modalActions actions used for modals
 * @param {*} expandActions actions used for expand
 * @param {*} isExpandable actions is expandable
 * @returns 
 */
export const Columns = ({ t, expandActions, isExpandable, actions }) => {
  const documentationChecks = isExpandable ? [
    {
      title: t('Title'),
      key: 'title',
      dataIndex: 'title',
      sorter: (a, b) => ('' + a.title).localeCompare(b.title),
      width: '25%',
      ellipsis: true,
    },
    {
      title: t('Determination'),
      key: 'outcome',
      width: '25%',
      dataIndex: 'outcome',
      ellipsis: true,
      render: (a, all) => renderStatus({ status: a.status, tab: 'documentationReview', options: all, t }),
    },
    {
      title: t('Sources'),
      key: 'sources',
      dataIndex: 'sources',
      sorter: (a, b) => a.sources.length - b.sources.length,
      width: '25%',
      ellipsis: true,
      render: (a, all) => Array.isArray(all.sources) ? t('Consolidated') : all?.label,
    },
    {
      title: t('Last Update'),
      key: 'updatedAt',
      dataIndex: 'updatedAt',
      width: 120,
      ellipsis: true,
      render: (d) => d ? moment(d).format('DD MMM YYYY') : '--',
    },
    {
      title: t(''),
      key: 'actions',
      dataIndex: 'actions',
      width: 60,
      render: (data, all) => {
        if (Array.isArray(all.sources)) {
          return null;
        }

        const items = [
          {
            key: "publish",
            disabled: true,
            label: (
              <Tooltip title={t('Document not available')}>
                {t('View Document')}
              </Tooltip>
            )
          }
        ]

        return (
          <div className="content-centered">
            <Dropdown menu={{ items }} trigger="click">
              <a onClick={e => e.preventDefault()}>
                <CustomIcon name="More" width={3} height={13} />
              </a>
            </Dropdown>
          </div>
        );
      }
    },

  ] : [
    {
      title: t('Title'),
      key: 'title',
      dataIndex: 'title',
      sorter: (a, b) => ('' + a.title).localeCompare(b.title),
      width: '34%',
      ellipsis: true,
    },
    {
      title: t('Determination'),
      key: 'outcome',
      width: '33%',
      dataIndex: 'outcome',
      ellipsis: true,
      sorter: (a, b) => ('' + a.outcome.status).localeCompare(b.outcome.status),
      render: (a, all) => renderStatus({ status: a.status, tab: 'documentationReview', options: all, t }),
    },
    {
      title: t('Last Update'),
      key: 'updatedAt',
      dataIndex: 'updatedAt',
      width: '33%',
      ellipsis: true,
      render: (d) => d ? moment(d).format('DD MMM YYYY') : '--',
    },
    {
      title: t(''),
      key: 'actions',
      dataIndex: 'actions',
      width: 60,
      render: (data) => {
        const items = [
          {
            key: "publish",
            disabled: true,
            label: (
              <Tooltip title={t('Document not available')}>
                {t('View Document')}
              </Tooltip>
            )
          }
        ]

        return (
          <div className="content-centered">
            <Dropdown menu={{ items }} trigger="click">
              <a onClick={e => e.preventDefault()}>
                <CustomIcon name="More" width={3} height={13} />
              </a>
            </Dropdown>
          </div>
        );
      }
    },
  ];

  return {
    managementSystems: documentationChecks,
    documentationChecks,
    checks: isExpandable ? [
      {
        title: t('KYC Checks'),
        key: 'title',
        dataIndex: 'title',
        sorter: (a, b) => ('' + a.title).localeCompare(b.title),
        width: '25%',
        ellipsis: true,
        render: (data, all) => all?.sources?.length ? data : '--',
      },
      {
        title: t('Sources'),
        key: 'sources',
        dataIndex: 'sources',
        sorter: (a, b) => a.sources.length - b.sources.length,
        width: '25%',
        render: (a, all) => Array.isArray(all.sources) ? t('Consolidated') : all?.label,
        ellipsis: true,
      },
      {
        title: t('Determination'),
        key: 'status',
        width: '25%',
        ellipsis: true,
        dataIndex: 'outcome',
        render: (a, all) => Array.isArray(all.sources) ? (
          <div className="flex">
            {renderStatus({ status: all.outcome, tab: 'counterpartyReview', t })}
            {(all.consolidation === 'verified' || all.consolidation === 'unverified')
              && (all.outcome === 'comply' || all.outcome === 'gap') ?
              renderStatus({ status: a, tab: 'counterpartyReview', options: all, t })
              : null}
          </div>
        ) : renderStatus({ status: all.outcome, tab: 'counterpartyReview', t }),
      },
      {
        title: t('Last Update'),
        key: 'updatedAt',
        dataIndex: 'updatedAt',
        width: '25%',
        ellipsis: true,
        render: (d) => d ? moment(d).format('DD MMM YYYY') : '--',
      },
      {
        title: t(''),
        key: 'actions',
        dataIndex: 'actions',
        width: 60,
        render: (data, all) => {
          if (!all?.sources) {
            return null;
          }

          const items = [
            {
              key: "publish",
              label: t('View Data'),
            },
            {
              key: "delete",
              onClick: () => {
                if (typeof actions.setActiveCheck === 'function') {
                  actions.setActiveCheck(all);
                }
              },
              label: t('Compliance Rules'),
            },
          ]

          return (
            <div className="content-centered">
              <Dropdown menu={{ items }} trigger="click">
                <a onClick={e => e.preventDefault()}>
                  <CustomIcon name="More" width={3} height={13} />
                </a>
              </Dropdown>
            </div>
          );
        }
      },
    ]
      : [
        {
          title: t('KYC Checks'),
          key: 'title',
          dataIndex: 'title',
          sorter: (a, b) => ('' + a.title).localeCompare(b.title),
          width: '34%',
          ellipsis: true,
          render: (data) => data,
        },
        {
          title: t('Determination'),
          key: 'outcome',
          dataIndex: 'outcome',
          sorter: (a, b) => ('' + a.outcome).localeCompare(b.outcome),
          render: (a) => renderStatus({ tab: 'counterpartyReview', status: a, t }),
          width: '33%',
          ellipsis: true,
        },
        {
          title: t('Last Update'),
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          ellipsis: true,
          width: '33%',
          render: (d) => d ? moment(d).format('DD MMM YYYY') : '--',
        },
        {
          title: t(''),
          key: 'actions',
          dataIndex: 'actions',
          width: 60,
          render: (data, all) => {
            const items = [
              {
                key: "publish",
                label: t('View Data')
              },
              {
                key: "delete",
                onClick: () => {
                  if (typeof actions.setActiveCheck === 'function') {
                    actions.setActiveCheck(all);
                  }
                },
                label: t('Compliance Rules'),
              },
            ]

            return (
              <div className="content-centered">
                <Dropdown menu={{ items }} trigger="click">
                  <a onClick={e => e.preventDefault()}>
                    <CustomIcon name="More" width={3} height={13} />
                  </a>
                </Dropdown>
              </div>
            );
          }
        },
      ],

    challenges: [
      {
        title: t('Identified Gaps'),
        key: 'title',
        width: '30%',
        dataIndex: 'title',
        sorter: (a, b) => ('' + a.title).localeCompare(b.title),
        render: (d, all) => d || all?.title || '--',
      },
      {
        title: t('Severity'),
        key: 'checks',
        width: '20%',
        dataIndex: 'checks',
        render: (a, all) => {
          let severity = 'minor';

          if (Array.isArray(a)) {
            if (a.length === 1) {
              return renderSeverity({ type: a[0].severity, t });
            }
            return null;
          } else {
            severity = all.severity;
          }
          return renderSeverity({ type: severity, t });
        },
      },
      {
        title: t('Challenges'),
        key: 'checks',
        dataIndex: 'checks',
        sorter: (a, b) => a.checks.length - b.checks.length,
        width: '30%',
        render: (a, b) => {
          let outcome = '';
          if (Array.isArray(a)) {
            if (a.length === 0) {
              outcome = '-';
            }
            if (a.length < 2) {
              outcome = a[0].criteria;
            }
            else {
              outcome = `${a.length} ${t('Challenges')}`;
            }
          } else if (typeof a === 'object') {
            outcome = a.criteria;
          } else {
            outcome = b?.criteria || '-';
          }

          return (
            <div className="cursor-pointer">
              {outcome}
            </div>
          )
        }
      },
      {
        title: t('Last Update'),
        key: 'updatedAt',
        dataIndex: 'updatedAt',
        // sorter: (a, b) => a.checks.length - b.checks.length,
        width: 100,
        render: (a, all) => {
          if (Array.isArray(all?.checks)) {
            return null;
          }

          return (
            <div className="cursor-pointer">
              {a ? moment(a).format('DD MMM YYYY') : '--'}
            </div>
          )
        }
      },
    ],
  }
};
